const React = require('react');
const css = require('./module.scss');
const Head = require('./head');
const Foot = require('./foot');
const Menu = require('./menu');
const Path = require('./path');

var Frame2 = React.createClass({
    getInitialState: function () {
        return {};
    },
    componentDidMount: function () {
        window.onload = function () {

        };
    },
    render: function () {
        return <div>
            <div ref="container" id="J_container">
                <Path path={this.props.path} isShowBack={this.props.isShowBack} />
                {this.props.children}
            </div>
        </div>;
    }
});

module.exports = Frame2;








// WEBPACK FOOTER //
// ./component/frame/frame2.js